import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AtbHomeService } from '../../../services/atbHome.service';
import { environment } from '../../../../environments/environment.prod';
import { NgxSpinnerService } from 'ngx-spinner';


declare var jQuery: any;

@Component({
  selector: 'app-hoteliers-structures-list',
  templateUrl: './hoteliers-structures-list.component.html',
  styleUrls: ['../../../app.component.css']
})


export class HoteliersStructuresListComponent implements OnInit {

baseUrl;
permitsBasePath;
queryStr;
data: any[] = new Array();

checkFirstPage;
private sub: any;

  constructor( private route: ActivatedRoute, private spinner: NgxSpinnerService, private router: Router, private atbService: AtbHomeService) { }

  ngOnInit() {

    this.route.params.subscribe((params) => {

        if ( params['token'] == undefined  ||  params['token'] == null ||  params['token'] == "" ) {
         this.checkFirstPage = false
        } else{
          this.checkFirstPage = true
        }
    });


    if (this.checkFirstPage == true)  {

      this.sub = this.route.params.subscribe(params => {
        var token  = params['token'];
        var user = params['user'];
        var language = params['language'];
        var role = params['role'];

        localStorage.setItem("token", token);
        localStorage.setItem("user", user)
        localStorage.setItem("language", language)
        localStorage.setItem("role", role)
        this.router.navigate(['/hoteliers/structure/structures'])
      });

    } else {

        // this.router.navigate(['/hoteliers/structure/structures'])
    }

    this.baseUrl = environment.baseUrl
    this.permitsBasePath = 'permessituristici';
    this.queryStr = 'strutture';
    this.testFunction()

  }

  testFunction() {
    this.spinner.show();

    this.atbService.getListFilter(this.permitsBasePath + '/' + this.queryStr).subscribe(
      (response) => {
      // Verificare outcome
      if (response.outcome.success === true) {
        this.data = response.results


        if (  this.data.length == 0){
          this.router.navigate(['/hoteliers/structure/new']);
        }

      this.spinner.hide()
      // console.log('Test', this.data);
    } else {
      this.spinner.hide()
    }

      },
      (error) => {
        console.log('Error ', error);
       // this.goToAtbAtHome();
       this.spinner.hide()
       this.router.navigate(['/hoteliers/structure/new']);

      }
      );
  }

  goToAtbAtHome() {
    window.location.href = this.baseUrl + '#mdl=home';
  }

  open() {
    jQuery('#sidebar').toggleClass('active');

  console.log('press')
  }

  goToNewStructure() {
    this.router.navigate(['/hoteliers/structure/new']);
  }

  editStructure(s) {
    localStorage.setItem('dataPassed', JSON.stringify(s));
    this.router.navigate(['/hoteliers/structure/edit']);
  }

  goToPermission(id, name, s) {
    localStorage.setItem('idStructure', id);
    localStorage.setItem('structureName', name);
    localStorage.setItem('dataPassed', JSON.stringify(s));

    this.router.navigate(['/hoteliers/signin']);
  }

  goToZTLTransit(id, name, s) {
    localStorage.setItem('idStructure', id);
    localStorage.setItem('structureName', name);
    localStorage.setItem('dataPassed', JSON.stringify(s));

    this.router.navigate(['/targhe/manage']);
  }

  editRooms(idStructure) {

    localStorage.setItem('idStructure', idStructure)
    this.router.navigate(['/hoteliers/structure/rooms']);
  }


}



// WEBPACK FOOTER //
// ./src/app/views/hoteliers-permits/hoteliers-structures-list/hoteliers-structures-list.component.ts